/**
 * @name 用户管理模块
 */
import { baseURL } from '@/api/base' // 导入接口域名列表
import axios from '@/utils/http' // 导入http中创建的axios实例
import type { Role } from '@/api/modules/systemManage/role'

export type User = {
	cnName: string
	firstLoginFlag: boolean
	loginName: string
	loginPwd: string
	realName: string
	roleList: Role[]
	userEmail: string
	userId: IdType
	userMobile: string
	userStatus: string
	bindTeacherId: IdType
	userHeadFile?: string[]
}
export type MainUserKeys = 'cnName' | 'loginName' | 'realName' | 'userEmail' | 'userMobile' | 'bindTeacherId'
export type UserInfoKeys = MainUserKeys | 'userId' | 'roleList' | 'userHeadFile'
export type UserInfo = Pick<User, UserInfoKeys>

// * 用户分页查询
export const getUserList: PageListApi<User> = params => axios.post(`${baseURL}/api/sysUser/pageUserList`, JSON.stringify(params))

// * 新增用户
export type AddUserParam = Pick<User, MainUserKeys> & { roleIdList: IdType[] }
export const addUser: (params: AddUserParam) => Promise<string> = params => axios.post(`${baseURL}/api/sysUser/addUser`, JSON.stringify(params))

// * 获取用户详情
export const getUserDetail: (userId: User['userId']) => Promise<UserInfo> = userId => axios.post(`${baseURL}/api/sysUser/getUserDetail/${userId}`)

// * 编辑用户
export type EditUserParam = AddUserParam & {
	userId: IdType
	userStatus: string
}
export const editUser: (params: EditUserParam) => Promise<string> = params => axios.put(`${baseURL}/api/sysUser/updateUser`, JSON.stringify(params))

// * 重置用户密码
export const resetUserPassWord: (userIdList: IdType[]) => Promise<string> = params => axios.put(`${baseURL}/api/sysUser/resetPassword`, JSON.stringify(params))

// * 更新用户头像
export const updateUserHeadFile: (params: { userHeadFile: [string] }) => Promise<string> = params =>
	axios.post(`${baseURL}/api/sysUser/updateUserHeadFile`, JSON.stringify(params))
// * 修改登录密码
export const updateLoginUserPwd: (params: Create<'newPwd' | 'oldPwd', string>) => Promise<string> = params =>
	axios.post(`${baseURL}/api/sysUser/updateLoginUserPwd`, JSON.stringify(params))